<template lang="pug">
  section
    .u-pbm
      div ・会社に雇用される労働者ではなく独立した事業主のため、労働基準法など適用外になります。
      div ・税金の申告（確定申告）などもご自身で行っていただきます。
      div ・契約期間は、契約終了または契約条件の変更の意思表示をしていない限り、１年間自動的に更新されるものとし、以降も同様とします。
      div ・契約期間中に中途解約することもございます。
      div ・お支払いは、当月末締めの翌月25日払いになります。翌月10日にシステム上で明細公開をし、20日まで明細修正期間を設けていますのでその間に修正などを行います。
      div ・原材料、交通費、通信費などは、ご負担いただきます。
      div ・成果物を納品、かつ報告までが業務になりますので、その間に不備があった場合の支払いができません。

    p.l-signup__text ※順次業務は増えますが、エリアによっては少ない場合がございますのでご了承ください。

</template>
<script lang="babel">
  export default {
    data () {
      return {
        name: 'contract'
      }
    },
    created () {
    },
    mounted () {
    },
    computed: {
    },
    methods: {

    }
  }
</script>
<style lang="scss">

</style>
